import React from "react";
import TablaLog from "js/components/TablaLog";

export const Log = props => {
  return <TablaLog />;
};

export default Log;
